(function () {

    const SKU_EXTENTIONS = [
        '-005', // US and Canada
        '-035', // UK
        '-205', // Brazil
        '-295', // Japan
        '-375', // Asia Pacific
        '-425', // EMEA
        '-B25', // Worldwide for Storage
        '-D05', // Argentina
        '-D65', // India
        '-DM5' // LATAM
    ]
    window.feHPEB2C.log('FE: 4047: start');
    if (typeof feProjectId === 'undefined') {
        var feProjectId = 'FE:4047';
    }
    let SelectorsDictionary = {
        //   CustomizeLink: "a.hpe-customize-link:visible"//on PDP
        AddToCartButton: "button.add-cart-btn",
        AppManSoftware: "app-management-software:visible",
        AppOS: "app-operating-systems",
        ArticleRows: "article.hpe-product-grid:not(.hpe-block-overflow)",
        CustomizeLink: "a.CCskuModalBtn.skuconfigurebuy",//on PDP
        ExtractSku: "div.hpeit-campaign-card-footer",
        GetQuoteButton: "button.hpeit-campaign-getQuoteButton",
        ShowSpecLink: "a.hpeit-campaign-specifications",
        SmartChoiceBadge: "div.campaign-NewBadge",
        HasBadge: "div.campaignPage-badge span",
        SvgTabIcons: "div.productConfigContainer svg.hpe-icon.CC-tab-icon",
        TileElement: "div.hpeit-campaignPage-tab-content",
        TileTextToHide: "p.hpeit-campaign-card-text,div.hpeit-campaign-card-body > div > div > span.hpeit-text-block"
    }
    let raw_txt = {
        "BetterTogether": "Better Together",
        "Customize": "Customize",
        "DblDownSec": "Double down on security with HPE ProLiant Server + Windows Server 2025",
        "HPEandWindowsServer2025": "HPE and Windows Server 2025",
        //    "ImageCaption": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
        "Personalize": "Personalize",
        "Promotion": "Promotion",
        "ShopNow": "Shop now",
        "SmartChoice": "Smart Choice",
        "SelectanAuthorizedReseller": "Select an Authorized Reseller",
        "Purchasefromoneofourresellersinyourregion": "Purchase from one of our resellers in your region"
    }

    //shameless copy from 4047.js, is the only shared code in 4047
    function getOidFromUrl(url) {
        url = url || window.location.href;
        const pIndex = url.indexOf('/p/');
        if (pIndex === -1) return '';
        const afterP = url.substring(pIndex + 3);
        const endIndex = afterP.indexOf('?') !== -1 ? afterP.indexOf('?') : (afterP.indexOf('#') !== -1 ? afterP.indexOf('#') : afterP.length);
        return afterP.substring(0, endIndex);
    }

    function shouldAutoOpenConfig() {
        return (window.feReusable.findGetParameter('fe_open') === 'config')
    }

    function onPageReady() {
        let txt = window['FEi18n'].ask(JSON.parse(JSON.stringify(raw_txt)));
        let FE_LOADER = (window.feReusable.findGetParameter('FE_LOADER') || '')

        function detectOpSysTab() {
            // <svg _ngcontent-c1="" class="hpe-icon CC-tab-icon"><use _ngcontent-c1="" xlink:href="#icon-operating-system"></use></svg>
            let opSysIcon = jQuery(SelectorsDictionary.SvgTabIcons).toArray().filter(svg => $(svg).html().indexOf('#icon-operating-system') > 0);
            return opSysIcon.length > 0 ? opSysIcon : null;
        }

        function detectManagementSoftwareTab() {
            let managementSoftwareIcon = jQuery(SelectorsDictionary.SvgTabIcons).toArray().filter(svg => $(svg).html().indexOf('#icon-management-software') > 0);
            return managementSoftwareIcon.length > 0 ? managementSoftwareIcon : null;
        }

        function beautifyOpSysTab() {
            let tabs = detectOpSysTab();//detectManagementSoftwareTab();//
            window.feHPEB2C.log('FE: 4047: beautifyOpSysTab()', tabs)
            if (!tabs) return;
            tabs.forEach(tab => {
                jQuery(tab).closest('section.hpe-configuration-carousel').addClass('fe-4047-mod-overflow-for-pill');

                let hdr = jQuery(tab).closest('section').addClass('fe-4047-conf-tab-has-pill');//  div.owl-item.active > section > header
                let pill = jQuery(`<div class="fe-4047-conf-tab-pill">${txt.Promotion}</div>`);
                hdr.prepend(pill);
                let promotTextBox = jQuery(`<div class="fe-4047-conf-better-together " style="z-index: 99999;"> ${txt.DblDownSec}</div>`);//<b>${txt.BetterTogether}:</b>
                jQuery(tab).closest('div.row').find('div.hpe-configuration-carousel__container').css('position', 'relative').append(promotTextBox);
            })

            setupClickEventWatcher()
        }

        function setupClickEventWatcher() {
            window.feUtils.observeDom({
                selector: 'div.config-option-part',
                callback: (mutations) => {
                    //  if (mutations.target.classList.contains('choicecontent')) {
                    setTimeout(function () {
                        window.feHPEB2C.log('FE: 4047: setupClickEventWatcher>cb>setTimeout()', jQuery(SelectorsDictionary.AppOS).length)
                        if (jQuery(SelectorsDictionary.AppOS).length > 0) {
                            // let tabOffset = jQuery('div.fe-4047-conf-tab-pill').closest('div.owl-item')
                            //     .offset().left;
                            // let offsetOfParent = jQuery('div.fe-4047-conf-tab-pill')
                            //     .closest('div.owl-stage-outer').offset().left;

                            jQuery('div.fe-4047-conf-better-together')
                                .addClass('fe-4047-show')
                            //     .css({
                            //         left:400// tabOffset - offsetOfParent + 100
                            //     })

                        } else {
                            jQuery('div.fe-4047-conf-better-together').removeClass('fe-4047-show')
                        }
                    }, 500);
                    //  }
                },
                config: {
                    attributes: false,
                    childList: true,
                    subtree: true
                }
            });
        }

        function skuHasWhitelistedExtention() {
            let sku = getSkuFromCurrentConfigModal();
            if (!sku) sku = getOidFromUrl();
            if (!sku) return false;
            window['feHPEB2C'].log('FE: 4047: skuHasWhitelistedExtention()', sku, (sku.length - 4));
            return SKU_EXTENTIONS.includes(sku.substring(sku.length - 4));
        }

        function getSkuFromCurrentConfigModal() {
            return window['digitalData'] && window['digitalData'].product[0] && window['digitalData'].product[0].productInfo?.productID;
        }

        function watchForConfigModal() {
            window['feHPEB2C'].log('FE: 4047: watchForConfigModal()');
            window.feUtils.observeDom({
                selector: 'div#CC-modal',
                callback: (mutations) => {
                    setTimeout(function () {
                        window['feHPEB2C'].log('FE: 4047: mutation found watchForConfigModal()', jQuery('div#CC-modal').is(':visible'))
                        if (jQuery('div#CC-modal').is(':visible') && (skuHasWhitelistedExtention() || shouldAutoOpenConfig())) {
                            window.feUtils.waitForConditions({
                                conditions: ['section.hpe-configuration-carousel', () => {
                                    return detectManagementSoftwareTab() != null;
                                }],
                                activity: feProjectId + '-3',
                                callback: onOpenConfig,
                            })
                        }

                    }, 1000);
                },
                config: {
                    attributes: true,
                    childList: false,
                    subtree: false
                }
            });
            if (shouldAutoOpenConfig()) {
                jQuery(SelectorsDictionary.CustomizeLink)[0].click();
            }
        }

        function onOpenConfig() {
            window['feHPEB2C'].log('FE: 4047: onOpenConfig()');
            setTimeout(() => {
                beautifyOpSysTab()
            }, 1000);
        }

        setTimeout(() => {
            watchForConfigModal();
        }, 1000);

    }

    window.feUtils.waitForConditions({
        conditions: ['body', () => {
            return window['FEi18n']?.isReady()
        }],
        activity: feProjectId,
        callback: onPageReady,
    })

})();
